class Controller {
  constructor(Events, $stateParams, Sections) {
    "ngInject";

    this.activeParams = $stateParams;

    this.filterEvent = Events.getFilterEvent("invoiceItems");
    this.sortEvent = Events.getSortEvent("invoiceItems");
    this.paginateEvent = Events.getPaginateEvent("invoiceItems");

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.sections = Sections.plansSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/invoiceItems/invoiceItems.controller.js